<template>
    <transition name="fade" mode="out-in">
        <div id="loading-order" class="row justify-content-center align-items-center" key="loading"
             v-if="order._id === undefined || !isUserLogged">
            <APILoading :font-size="30" :text="$t('shared.apiLoading.getYourOrder')"/>
        </div>
        <div key="checkoutComplete" v-else id="checkout-complete">
            <CheckoutCompletePayBill v-if="canPayBill" :order="order" id="how-to-pay-bill" class="mb-5"/>
            <PageTitle :title="$t('CheckoutComplete.title')" class="mb-4"/>
            <div class="container mb-2">
                <div class="row justify-content-center">
                    <div class="col-lg-4 col-md-8">
                        <img alt="Checkout complete" id="checkout-complete-svg" :src="checkoutCompleteSVG"/>
                    </div>
                    <div class="col-12 text-center mt-4">
                        <h2>
                            <i class="fa fa-check-circle text-success"/>
                            {{$t("CheckoutComplete.orderSuccessful")}}
                        </h2>
                        <h2 v-if="order.status.payment === 'error'" class="mb-2">
                            <i class="fas fa-exclamation-triangle text-warning"/>
                            {{$t("CheckoutComplete.orderPaymentFailed")}}
                        </h2>
                        <h3 v-else-if="order.status.payment === 'waiting'" v-html="$t('CheckoutComplete.dontForgetToPay')"/>
                        <div class="row">
                            <div class="col-12">
                                <a href="#" v-if="canPayBill" v-scroll-to="'#how-to-pay-bill'" class="btn btn-warning btn-lg">
                                    {{$t("CheckoutComplete.payMyBill")}}
                                </a>
                            </div>
                        </div>
                        <div v-if="order.status.payment !== 'error'" class="row">
                            <div class="col-12 d-flex flex-column align-items-center">
                                <DownloadBilling :order="order" classes="btn btn-danger btn-lg" v-if="order.billing.method !== 'agreement'"
                                                 :display-tooltip="false"/>
                                <router-link class="btn btn-secondary" to="/profile/orders">
                                    {{$t('CheckoutComplete.checkOrders')}}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="hermesAPIConfig.client === 'imprimer-vos-livres'">
                <PageTitle :title="$t('CheckoutComplete.nextSteps')" class="mb-4"/>
                <div class="container">
                    <div class="col-12">
                        <ol>
                            <li v-html="$t('CheckoutComplete.filesTreatment')"/>
                            <li v-html="$t('CheckoutComplete.filesValidation')"/>
                            <li v-html="$t('CheckoutComplete.production')"/>
                            <li v-html="$t('CheckoutComplete.shipping')"/>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import VueScrollTo from "vue-scrollto";
import { mapGetters, mapActions } from "vuex";
import PageTitle from "../../shared/Misc/PageTitle";
import CheckoutCompletePayBill from "./CheckoutCompletePayBill/CheckoutCompletePayBill";
import Order from "../../../classes/Order";
import Product from "../../../classes/Product";
import APILoading from "../../shared/Misc/APILoading";
import DownloadBilling from "../../shared/Order/DownloadBilling";
import { importSVG } from "@/helpers/file";

export default {
    name: "CheckoutComplete",
    components: {DownloadBilling, APILoading, CheckoutCompletePayBill, PageTitle},
    data() {
        return {
            order: new Order(),
        };
    },
    computed: {
        ...mapGetters("user", {
            isUserLogged: "isLogged",
        }),
        ...mapGetters("config", {
            hermesAPIConfig: "hermesAPI",
        }),
        checkoutCompleteSVG() {
            return importSVG("checkout_complete", this.hermesAPIConfig.client);
        },
        canPayBill() {
            return this.order.status.payment === "waiting" || this.order.status.payment === "error";
        },
    },
    async created() {
        if (this.$route.query.order === undefined) {
            return this.$router.push("/");
        }
        return !this.isUserLogged ? await this.checkUserAuthentication() : await this.getOrder();
    },
    methods: {
        ...mapActions("user", {
            checkUserAuthentication: "checkUserAuthentication",
        }),
        async getOrder() {
            try {
                const response = await this.$hermesAPI.getOrder(this.$route.query.order);
                this.order = new Order(response.data);
                if (this.$route.query.scroll === "how-to-pay-bill") {
                    setTimeout(() => {
                        VueScrollTo.scrollTo("#how-to-pay-bill");
                    }, 1000);
                }
            } catch (err) {
                this.$error.displayError(err);
            }
        },
        updateProduct(updatedProduct) {
            const idx = this.order.products.findIndex(({ _id }) => _id === updatedProduct._id);
            if (idx !== -1) {
                this.order.products.splice(idx, 1, new Product(updatedProduct));
            }
        },
    },
    watch: {
        isUserLogged: {
            handler(isLogged) {
                if (!isLogged) {
                    this.checkUserAuthentication();
                } else {
                    this.getOrder();
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>

    #loading-order {
        height: 30vh;
    }

</style>